import isProd from './isProduction.ts'
import { HEADING, SUBHEADING } from './defaults'

export const endpoints = (prod = isProd()) => ({
  authApiUrl: prod ? 'https://www.bibme.org/api/auth' : 'https://playground.bibme.org/api/auth',
  editorBaseUrl: prod ? 'https://writing.bibme.org' : 'https://writing-playground.bibme.org',
})

const bibme = ({
  site = 'bibme',
  headingText = HEADING,
  subheadingText = SUBHEADING,
  pasteOnly = false,
  alignText = 'center',
  initRSW = true,
  initFreshToken = true,
} = {}) => {
  const { editorBaseUrl, authApiUrl } = endpoints()

  return {
    headingText,
    subheadingText,
    authApiUrl,
    editorBaseUrl,
    pasteOnly,
    alignText,
    site,
    initFreshToken,
    initRSW,
  }
}

export default bibme
